'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { adminShellOwnsMain } from '@/components/layout/main-content';
import { reportClientError } from '@/lib/telemetry/client-error';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const ownsMain = adminShellOwnsMain(usePathname());
  const Container = ownsMain ? 'main' : 'div';
  useEffect(() => {
    console.error('[GlobalError]', error);
    // Phase 0.3a — ensure the "team has been notified" copy is actually true.
    reportClientError({
      kind: 'render',
      error,
      context: { boundary: 'global', digest: error.digest },
    });
  }, [error]);

  return (
    <Container id={ownsMain ? 'main-content' : undefined} tabIndex={ownsMain ? -1 : undefined}
      className="flex min-h-screen flex-col items-center justify-center gap-6 p-8 text-center">
      <div className="rounded-full bg-destructive/10 p-4">
        <svg className="h-8 w-8 text-destructive" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
        </svg>
      </div>
      <h1 className="text-2xl font-bold">Something went wrong</h1>
      <p className="text-muted-foreground max-w-md">
        An unexpected error occurred. Our team has been notified.
      </p>
      <button
        onClick={reset}
        className="rounded-md bg-primary-action px-6 py-2.5 text-sm font-medium text-primary-foreground hover:bg-primary-action/90 transition-colors"
      >
        Try Again
      </button>
    </Container>
  );
}
